import React from "react";
import { connect } from "react-redux";
import moment from "moment";
import './style.css';
import LayoutWrapper from '../../layouts/LayoutWrapper.js';
import {
  Table,
  Button,
  Modal,
  Spin,
  message,
  Icon,
  Divider,
  Input,
  InputNumber,
  Form,
  DatePicker,
  Select,
  Tabs
} from 'antd';
import bestEmployeeStatisticService from '../../services/WorkReport/best-employee-statistic-service';

class BestEmployeeStatistic extends React.Component {

  state = {
    start_date: "",
    end_date: "",
    page: 1,
    Modal: false,
    tab_key: 0
  }

  componentWillMount() {
    this.fetchBestEmployeeList();

  }

  fetchBestEmployeeList = (params) => {

    bestEmployeeStatisticService.getBestEmployeeList(params, res => {
      console.log(res)
      if (res.data.Success === true) {
        this.setState({
          bestEmployeeList: res.data.Object,
        });
      }

    })
  }

  setStartDateFilter = (value, date) => {
    let params = {
      start_date: date
    }
    this.setState({
      start_date: date,
    });
    let gets = {};
    for (let key in this.state) {
      if (this.state[key] !== undefined && key !== 'bestEmployeeList'&&key!='noSubmitList') {
        gets[key] = this.state[key];
      }
    }
    gets = { ...gets, ...params }
    this.setState(params);
    this.fetchList(gets);
  }

  setEndDateFilter = (value, date) => {
    let params = {
      end_date: date
    }
    this.setState({
      end_date: date,
    });
    let gets = {};
    for (let key in this.state) {
      if (this.state[key] !== undefined && key !== 'bestEmployeeList'&&key!='noSubmitList') {
        gets[key] = this.state[key];
      }
    }
    gets = { ...gets, ...params }
    this.setState(params);
    this.fetchList(gets);
  }

  clickRow = (record) => {
    let params = {
      start_date: this.state.start_date,
      end_date: this.state.end_date,
      job_number: record.job_number
    }
    console.log(record);
    bestEmployeeStatisticService.getBestEmployeeReason(params, res => {
      console.log(res)
      if (res.data.Success === true) {
        this.setState({
          bestEmployeeReason: res.data.Object,
        });
      }

    })
    this.setState({ Modal: true });
  }
  closeModal() {
    this.setState({ Modal: false });
  }
  actions = {};
  tabChange = (key) => {
    console.log(key);
    this.setState({ tab_key: key });
    let gets = {};
    for (let key in this.state) {
      if (this.state[key] !== undefined&& key !== 'bestEmployeeList'&&key!='noSubmitList') {
        gets[key] = this.state[key];
      }
    }
    if (key == 0) {
      this.fetchBestEmployeeList(gets);
    } else if (key == 1) {
      gets = { ...gets, type: 'day' };
      bestEmployeeStatisticService.getNosubmitList(gets, res => {
        if (res.data.Success === true) {
          this.setState({
            noSubmitList: res.data.Object,
          });
        }
      })
    } else {
      gets = { ...gets, type: 'week' };
      bestEmployeeStatisticService.getNosubmitList(gets, res => {
        if (res.data.Success === true) {
          this.setState({
            noSubmitList: res.data.Object,
          });
        }

      })
    }
   // this.fetchList(gets);
  }
  fetchList = (params) => {
    console.log(this.state.tab_key);
    if (this.state.tab_key == 0) {
      this.fetchBestEmployeeList(params);
    } else if (this.state.tab_key == 1) {
      params = { ...params, type: 'day' };
      bestEmployeeStatisticService.getNosubmitList(params, res => {
        if (res.data.Success === true) {
          this.setState({
            noSubmitList: res.data.Object,
          });
        }
      })
    } else {
      params = { ...params, type: 'week' };
      bestEmployeeStatisticService.getNosubmitList(params, res => {
        if (res.data.Success === true) {
          this.setState({
            noSubmitList: res.data.Object,
          });
        }

      })
    }
  }

  render() {
    const columns = [{
      title: '工号',
      dataIndex: 'job_number',
      key: 'job_number',
    }, {
      title: '员工姓名',
      dataIndex: 'employee_name',
      key: 'employee_name',
    }, {
      title: '部门',
      dataIndex: 'department_name',
      key: 'department_name',
    }, {
      title: '职位',
      dataIndex: 'position_name',
      key: 'position_name',
    }, {
      title: '票数',
      dataIndex: 'vote',
      key: 'vote',
    }];
    const columns2 = [{
      title: '工号',
      dataIndex: 'job_number',
      key: 'job_number',
    }, {
      title: '员工姓名',
      dataIndex: 'employee_name',
      key: 'employee_name',
    }, {
      title: '部门',
      dataIndex: 'department_name',
      key: 'department_name',
    }, {
      title: '日期',
      dataIndex: 'date',
      key: 'date',
    }];
    const columns3 = [{
      title: '工号',
      dataIndex: 'job_number',
      key: 'job_number',
    }, {
      title: '员工姓名',
      dataIndex: 'employee_name',
      key: 'employee_name',
    }, {
      title: '部门',
      dataIndex: 'department_name',
      key: 'department_name',
    }];
    const reason_columns = [{
      title: '推荐人',
      dataIndex: 'referer',
      key: 'referer',
      width: 100
    }, {
      title: '原因',
      dataIndex: 'reason',
      key: 'reason',
      width: 600,
      render: (text, record) => (
        <div style={{ wordWrap: 'break-word', wordBreak: 'break-all' }}>
          {text}
        </div>
      ),
    }];



    const { TabPane } = Tabs;
    return (<div className="app-module-item">
      <div style={{ marginBottom: "20px" }}>

        <div className="colAction" style={{ float: "left", margin: "0px 10px 10px 0px" }}>
          <span style={{ marginRight: "5px" }}>开始时间 : </span>
          <DatePicker onChange={this.setStartDateFilter}
            value={this.state.start_date ?
              moment(this.state.start_date, "YYYY-MM-DD") :
              null} />
        </div>
        <div className="colAction" style={{ float: "left", margin: "0px 10px 10px 0px" }}>
          <span style={{ marginRight: "5px" }}>结束时间 : </span>
          <DatePicker onChange={this.setEndDateFilter}
            value={this.state.end_date ?
              moment(this.state.end_date, "YYYY-MM-DD") :
              null} />
        </div>
        <div style={{ clear: "both" }}></div>
      </div>
      <Modal width="800px"
        visible={this.state.Modal}
        destroyOnClose={true}
        onCancel={this.closeModal.bind(this)}
        footer={<Button type="back" onClick={this.closeModal.bind(this)}>关闭</Button>}>
        <div style={{ textAlign: "center", margin: "20px 0px 20px" }}>
          <Table columns={reason_columns} pagination={false} dataSource={this.state.bestEmployeeReason} />
        </div>
      </Modal>
      <Tabs defaultActiveKey="0" onChange={this.tabChange}>
        <TabPane tab="最佳员工" key="0">
          <div>
            <Table columns={columns} onRow={(record) => {
              return {
                onClick: this.clickRow.bind(this, record)
              }
            }} dataSource={this.state.bestEmployeeList} scroll={{ x: 1010 }} />
          </div>
        </TabPane>
        <TabPane tab="未交日报" key="1" >
          <div>
            <Table columns={columns2} dataSource={this.state.noSubmitList}/>
          </div>
        </TabPane>
        <TabPane tab="未交周报" key="2">
          <div>
            <Table columns={columns2}   dataSource={this.state.noSubmitList}/>
          </div>
        </TabPane>
      </Tabs>

    </div>)
  }
}

const mapStateToProps = state => {
  return {

  }
}

const mapDispatchToProps = {

}

BestEmployeeStatistic = Form.create()(BestEmployeeStatistic);

export default LayoutWrapper(connect(mapStateToProps, mapDispatchToProps)(BestEmployeeStatistic));





// WEBPACK FOOTER //
// ./src/routes/WorkReport/BestEmployeeStatistic.js